// Generated by ReScript, PLEASE EDIT WITH CARE


var value = {
    "route_polyline": "ulxxCi{kpIjAcCd@cAb@XbAl@lGpDtA|@NP@FBLHHLBLEHK@M?CPQxBoAn@UP^jA~Cr@~Ah@|@^^rAtAAP?HADEHIB_@LKFEFCT@D@BeA|@GGCCC?K?mAdAGH?NFN_@ZOGIAOHERBH",
    "vehicle_wise_quotations": [
        {
            "vehicle_id": 1,
            "quotation_uuid": "0000000-0000-0000-0000-000000000",
            "fare_info": {
                "fare": 73,
                "min_paytm_amount": 73,
                "min_paytm_amount_with_credits": 0,
                "applied_coupon": null,
                "subscription_discount": null,
                "total_discount": 0.0,
                "description": null
            },
            "bill_details": {
                "fare_breakup": [
                    [
                        {
                            "field_type": "trip_fare",
                            "title": "Trip Fare",
                            "subtext": "(incl. Toll)",
                            "value": 69.2,
                            "payable_type": "normal"
                        },
                        {
                            "field_type": "vat",
                            "title": "VAT",
                            "value": 3.46,
                            "payable_type": "due"
                        }
                    ]
                ],
                "net_fare": 71.66,
                "previous_dues": null,
                "porter_gold_fee": null,
                "porter_credits_applied": null,
                "amount_payable": 73
            },
            "subscription_info": {
                "status": "not_available"
            },
            "book_cta_info_text": null,
            "value_added_services": [
                {
                    "field_type": "labour",
                    "off_messages": [
                        "Fare doesn't include labour charges for loading \u0026 unloading"
                    ],
                    "services": [
                        {
                            "is_enabled": false,
                            "field_type": "helper"
                        },
                        {
                            "is_enabled": false,
                            "field_type": "helper_plus_labour"
                        }
                    ]
                }
            ]
        },
    ],
    "wallet_info": {
        "paytm_wallet": {
            "login_status": false,
            "balance": null,
            "balance_api_status": "unprocessable_entity"
        },
        "porter_wallet": {
            "amount": 201.0,
            "payable": false
        }
    },
    "nearby_vehicle_drivers": [
        {
            "show_vehicle": true,
            "vehicle_id": 1,
            "driver_locs": [],
            "eta_mins": null,
            "booking_enabled": true,
            "booking_disabled_msg": "NOT AVAILABLE\nCheck later",
            "book_till_x_mins": 20,
            "show_vehicle_availability_text": true,
            "dil_uuid": "0000000-0000-0000-0000-000000000"
        }
    ],
    "select_vehicle_id": 2,
    "porter_gold_details": {
        "is_cancellable": false,
        "benefits": []
    }
};

export {
  value ,
  
}
/* No side effect */
